import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ContactForm } from '@metlas/contact';
import '../../property-management/src/PropertyManagement.css';

const ROTATING_PHRASES = [
  'qualified capital in a few clicks.',
  'weeks of prospecting cut to hours.',
  'institutional-grade underwriting.',
  'granular submarket data.',
  'property management on autopilot.',
  'institutional speed and scale.',
];

const CASE_STUDIES = [
  {
    slug: '/RE-investor/lp-prospecting',
    title: 'LP prospecting',
    quote:
      'We are a three-person team raising equity on every deal, so prospecting used to mean weeks of LinkedIn and cold lists. Now we filter by check size and track record, see who has actually written checks like ours, and send outreach that speaks to each investor’s strategy. We reach more LPs in a week than we used to in a quarter.',
    role: 'Managing Partner',
    company: 'Boutique real estate investment firm, 3-person team',
  },
  {
    slug: '/RE-investor/underwriting',
    title: 'Underwriting',
    quote:
      'Without an analyst on staff, every OM meant a night in Excel before we could even say maybe. Now we drop the OM in and have the cash flow, returns and a list of the claims that don’t check out within minutes. We pass on bad deals faster and move on the good ones with confidence.',
    role: 'Managing Partner',
    company: 'Boutique real estate investment firm, 3-person team',
  },
  {
    slug: '/property-management/app',
    title: 'Property management',
    quote:
      'Leases, rent, repairs and renewals used to live in five different places. Now our tenants handle most of it themselves in the app, and the to-dos and reminders it manages for us mean nothing slips through the cracks.',
    role: 'Property Manager',
    company: 'LMT Homes Corporation',
  },
];

const REInvestor: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isFading, setIsFading] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFading(true);
      setTimeout(() => {
        setPhraseIndex((prev) => (prev + 1) % ROTATING_PHRASES.length);
        setIsFading(false);
      }, 400);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="re-page">
      <div className="re-bg">
        <div className="re-nebula re-nebula-1" />
        <div className="re-nebula re-nebula-2" />
        <div className="re-nebula re-nebula-3" />
      </div>

      <div className={`re-content ${isVisible ? 'visible' : ''}`}>
        <nav className="re-nav">
          <Link to="/" className="re-back">
            ← Back to Metlas
          </Link>
        </nav>

        <section className="re-hero">
          <h1 className="re-headline">
            The operating system for real estate investors,{' '}
            <span className={`re-rotating ${isFading ? 'fade-out' : 'fade-in'}`}>
              {ROTATING_PHRASES[phraseIndex]}
            </span>
          </h1>
        </section>

        <section className="re-case-studies">
          <h2 className="re-case-study-title">Case Studies</h2>
          <div className="re-cs-grid">
            {CASE_STUDIES.map((cs) => (
              <article key={cs.slug} className="re-cs-card">
                <h3 className="re-cs-card-title">{cs.title}</h3>
                <p className="re-cs-quote">{cs.quote}</p>
                <p className="re-cs-attrib">
                  <span className="re-cs-role">{cs.role}</span>
                  <span className="re-cs-company">{cs.company}</span>
                </p>
                <Link className="re-cs-demo-btn" to={cs.slug}>
                  See demo →
                </Link>
              </article>
            ))}
          </div>
        </section>
      </div>

      <aside className="re-contact-float">
        {contactOpen ? (
          <div className="re-contact-panel">
            <button
              type="button"
              className="re-contact-close"
              onClick={() => setContactOpen(false)}
              aria-label="Close contact form"
            >
              ✕
            </button>
            <ContactForm variant="float" />
          </div>
        ) : (
          <button
            type="button"
            className="re-contact-pill"
            onClick={() => setContactOpen(true)}
          >
            Book a Demo
          </button>
        )}
      </aside>
    </div>
  );
};

export default REInvestor;
